import {
  commonsOtherDocs3,
  commonsOtherDocs4,
  concession,
  revisedConcessionLetter,
  revisedDocsCommons,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const RevisaoCPADocs = () => {
  const rules = {
    anexoCartaRevisada: dynamicRule('required'),
    anexoCartaInicial: dynamicRule('required'),
    anexoSB40Etc: dynamicRule('tempoINSS'),

    anexoSentecaJudicial: dynamicRule('revisaoJudicial'),
    anexoCienciaConcessao: dynamicRule('naoJulgado'),
    anexoTeor: dynamicRule('naoJulgado'),

    anexoMovimentacaoProcesso: dynamicRule('julgado'),
    anexoDefinitiva: dynamicRule('julgado'),

    anexoMovimentacaoProcessualAtualizada: dynamicRule('revisaoJudicial'),
  };

  const docs = {
    commons: [...revisedConcessionLetter],
    Administrativa: [...commonsOtherDocs3],
    'Tutela Antecipada': [
      ...revisedDocsCommons,
      ...concession,
      ...commonsOtherDocs4,
      {
        name: 'anexoTeor',
        label:
          'Certidão de pé ou inteiro teor*' +
          'Decisões de Liminares ou de Mérito do Processo*',
      },
    ],
    Definitiva: [
      ...revisedDocsCommons,
      ...commonsOtherDocs4,
      {
        name: 'anexoMovimentacaoProcesso',
        label: 'Movimentação do processo*',
      },
      {
        name: 'anexoDefinitiva',
        label:
          'Certidão de objeto e pé ou inteiro teor* OU Certidão de Transitou em Julgado* OU Decisões de Liminares ou de Mérito do Processo*',
      },
    ],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
